<template>
  <b-nav-item-dropdown
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu-media"
      right
  >
    <template #button-content>
      <feather-icon
          :badge="$store.state.request.requests.length"
          badge-classes="bg-danger"
          class="text-body"
          icon="TwitchIcon"
          size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          درخواست های ورودی
        </h4>
        <b-badge
            pill
            variant="light-primary"
            v-show="$store.state.request.requests.length"
        >
          {{ $store.state.request.requests.length }} جدید
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
    >
      <b-link
          v-for="request in $store.state.request.requests"
          :key="request.id"
          :to="{path:`/requests/${request.id}`}"
      >
        <b-media>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ request.title }}
            </span>
          </p>
        </b-media>
      </b-link>

    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          block
          @click="$router.push({name: 'Requests_Inbox'})"
      >مشاهده تمام درخواست ها
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { getUserData } from '@/auth/utils'

export default {
  name: 'RequestsNavBar',
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      requests: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      }
    }
  },
  methods: {
    getRequests() {
      this.$http.get(`requests/notification`)
          .then(({ data }) => {
            store.commit('request/ADD_REQUEST_TO_LIST', data)

          })
    },
    async listen() {
      this.$notification.requestPermission()
      const router = this.$router

      setTimeout(() => {
        this.$echo
            .channel(`.request${this.$store.state.user.data.id}`)
            .listen('.NewRequestEvent', (data) => {
              let requests = this.$store.state.request.requests
              if (requests.some((request, index) => {
                if (request.id === data.id) {
                  requests.splice(index, 1)
                  requests.unshift(data)
                  return true
                }
                return false
              })) {
                store.commit('request/ADD_REQUEST_TO_LIST', requests)
              }

              this.$bvToast.toast(data.title ?? '', {
                title: 'درخواست جدیدی دریافت شد',
                variant: 'info',
                toaster: 'b-toaster-top-left'
              })
              this.$notification.show('درخواست جدید', {
                body: data.title ?? ''
              }, {
                onclick: function () {
                  router.push({
                    name: 'Requests_Detail',
                    params: { 'id': data.id }
                  })
                },
              })
            })
            .listen('.ReviewRequestEvent', (data) => {
              let requests = this.$store.state.request.requests
              if (requests.some((request, index) => {
                if (request.id === data.id) {
                  requests.splice(index, 1)
                  requests.unshift(data)
                  return true
                }
                return false
              })) {
                store.commit('request/ADD_REQUEST_TO_LIST', requests)
              }
              this.$bvToast.toast(data.title, {
                title: 'نیاز به بازنگری',
                variant: 'primary',
                toaster: 'b-toaster-top-left'
              })
              this.$notification.show('بازنگری درخواست', {
                body: ata.title ?? ''
              }, {
                onclick: function () {
                  router.push({
                    name: 'Requests_Detail',
                    params: { 'id': data.id }
                  })
                },
              })
            })
            .listen('.RejectRequestEvent', (data) => {
              let requests = this.$store.state.request.requests
              if (requests.some((request, index) => {
                if (request.id === data.id) {
                  requests.splice(index, 1)
                  requests.unshift(data)
                  return true
                }
                return false
              })) {
                store.commit('request/ADD_REQUEST_TO_LIST', requests)
              }
              this.$bvToast.toast(data.title, {
                title: 'رد درخواست',
                variant: 'danger',
                toaster: 'b-toaster-top-left'
              })

              this.$notification.show('رد درخواست', {
                body: data.title ?? ''
              }, {
                onclick: function () {
                  router.push({
                    name: 'Requests_Detail',
                    params: { 'id': data.id }
                  })
                },
              })
            })

      }, 3000)

    },
  },

  mounted() {
    this.getRequests()
    this.listen()
  }
}
</script>

<style>

</style>
